import { CheckCircle2, Phone, TriangleAlert } from "lucide-react";
import { formatDateHeure } from "@/lib/format";

const LIGNES = [["fiches", "Fiches"], ["commentaires", "Commentaires"], ["evenements", "Événements"]];

export const Rapport = ({ r }) => {
  const ok = r.ecarts.length === 0;
  return (
    <section className="at-card p-5 space-y-4" data-testid="migration-report">
      <div>
        <p className="font-bold">Rapport de contrôle — {r.lot === "echantillon" ? "échantillon" : "import complet"}</p>
        <p className="text-xs at-muted">{formatDateHeure(r.date)} · {r.par}</p>
      </div>
      <div className="grid grid-cols-[1fr_auto_auto] gap-x-4 gap-y-2 text-sm">
        <span className="at-label">Élément</span><span className="at-label text-right">noCRM</span><span className="at-label text-right">CRM</span>
        {LIGNES.map(([k, l]) => (
          <div key={k} className="contents" data-testid={`migration-report-row-${k}`}>
            <span>{l}</span><span className="text-right font-semibold" data-testid={`migration-report-before-${k}`}>{r.avant[k]}</span>
            <span className="text-right font-semibold" data-testid={`migration-report-after-${k}`} style={{ color: r.avant[k] === r.apres[k] ? "var(--success)" : "var(--danger)" }}>{r.apres[k]}</span>
          </div>
        ))}
      </div>
      <p className="text-sm" data-testid="migration-report-summary">{r.creees} créée(s), {r.mises_a_jour} mise(s) à jour, {r.commentaires_ajoutes} commentaire(s) ajouté(s), {r.non_attribuees} fiche(s) non attribuée(s).</p>
      <div className="at-soft p-3 text-sm space-y-1" data-testid="migration-report-ringover">
        <p className="font-semibold flex items-center gap-2"><Phone size={15} />Appels Ringover</p>
        <p>{r.ringover.rattaches} rattaché(s), {r.ringover.deja_rattaches} déjà rattaché(s), {r.ringover.sans_fiche} sans fiche correspondante.</p>
        {r.ringover.numeros_multiples.map((m) => (
          <p key={m.numero} className="text-xs at-muted break-words">{m.numero} correspond à plusieurs fiches : rattaché à la plus récente ({m.fiche}).</p>
        ))}
      </div>
      {ok ? (
        <p className="text-sm font-semibold flex items-center gap-2" style={{ color: "var(--success)" }} data-testid="migration-report-ok"><CheckCircle2 size={16} />Aucun écart : aucune donnée perdue.</p>
      ) : (
        <div className="space-y-1" data-testid="migration-report-gaps">
          <p className="text-sm font-semibold flex items-center gap-2" style={{ color: "var(--danger)" }}><TriangleAlert size={16} />{r.ecarts.length} écart(s)</p>
          {r.ecarts.slice(0, 50).map((x, i) => <p key={i} className="text-xs break-words">#{x.nocrm_id} {x.titre} : {x.probleme}</p>)}
        </div>
      )}
    </section>
  );
};
